<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("CRM Transaction") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("todate") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getCrmTransactionData()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>
      <div
        style="overflow-x:scroll;width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th
              v-for="(headers, headersIndex) in headersArr"
              :key="headersIndex"
              >{{ headers }}</th
            >
          </thead>
          <tbody v-if="crmTransactionRecords.length > 0">
            <tr
              v-for="(crmTransaction,
              crmTransactionIndex) in crmTransactionRecords"
              :key="crmTransactionIndex"
            >
              <td>{{ crmTransaction.Transaction }}</td>
              <td>{{ crmTransaction.TransactionDateandTime }}</td>
              <td>{{ crmTransaction.ScreeningShowDateandTime }}</td>
              <td>{{ crmTransaction.STAN }}</td>
              <td>{{ crmTransaction.BookingID }}</td>
              <td>{{ crmTransaction.ShowBizzBookingID }}</td>
              <td>{{ crmTransaction.QRCodeHTML }}</td>
              <td>{{ crmTransaction.PickUpCode }}</td>
              <td>{{ crmTransaction.ProviderReceiptNumber }}</td>
              <td>{{ crmTransaction.AuthCode }}</td>
              <td>{{ crmTransaction.CardNumber }}</td>
              <td>{{ crmTransaction.PosBookingId }}</td>
              <td>{{ crmTransaction.ExperienceType }}</td>
              <td><input type="text" v-model="crmTransaction.FirstName"/></td>
              <td><input type="text" v-model="crmTransaction.LastName"/></td>
              <td><input type="text" v-model="crmTransaction.Email"/></td>
              <td><input type="text" v-model="crmTransaction.Mobile"/></td>
              <td>{{ crmTransaction.UpdatedEmails }}</td>
              <td>{{ crmTransaction.OrderID }}</td>
              <td>{{ crmTransaction.NameofSeats }}</td>
              <td>{{ crmTransaction.NumberOfSeats }}</td>
              <td>{{ crmTransaction.TransactionValue }}</td>
              <td>{{ crmTransaction.ConvenienceFee }}</td>
              <td>{{ crmTransaction.TicketPrice }}</td>
              <td>{{ crmTransaction.Discount }}</td>
              <td>{{ crmTransaction.DiscountRemark }}</td>
              <td>{{ crmTransaction.RRN }}</td>
              <td>{{ crmTransaction.Description }}</td>
              <td>{{ crmTransaction.GatewayName }}</td>
              <td>{{ crmTransaction.BookStatus }}</td>
              <td>{{ crmTransaction.IsRefundActive }}</td>
              <td>{{ crmTransaction.RefundStatus }}</td>
              <td>{{ crmTransaction.CinemaBranch }}</td>
              <td>{{ crmTransaction.ScreenName }}</td>
              <td>{{ crmTransaction.RefundedBy }}</td>
              <td><input type="text" v-model="crmTransaction.Movie"/></td>
              <td :key="crmTransactionIndex + 'crm'"
                ><button
                  class="btn-blue-lg w-100"
                  @click="submitData(crmTransaction)"
                  >Send</button
                ></td
              >
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="headersArr.length">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import axios from "axios";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        crmTransactionRecords: [],
        headersArr: [
          "Transaction",
          "TransactionDateandTime",
          "ScreeningShowDateandTime",
          "STAN",
          "BookingID",
          "ShowBizzBookingID",
          "QRCodeHTML",
          "PickUpCode",
          "ProviderReceiptNumber",
          "AuthCode",
          "CardNumber",
          "PosBookingId",
          "ExperienceType",
          "FirstName",
          "LastName",
          "Email",
          "Mobile",
          "UpdatedEmails",
          "OrderID",
          "NameofSeats",
          "NumberOfSeats",
          "TransactionValue",
          "ConvenienceFee",
          "TicketPrice",
          "Discount",
          "DiscountRemark",
          "RRN",
          "Description",
          "GatewayName",
          "BookStatus",
          "IsRefundActive",
          "RefundStatus",
          "CinemaBranch",
          "ScreenName",
          "RefundedBy",
          "Movie",
          "Send Data",
        ],
      };
    },
    beforeMount() {
      this.getCrmTransactionData();
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    mounted() {},
    methods: {
      moment,
      getCrmTransactionData() {
        let loader = this.$loading.show();
        this.crmTransactionRecords = [];
        let payload = {
          fromDateTime: moment(this.fromDate).format("YYYY-MM-DD"),
          toDateTime: moment(this.toDate).format("YYYY-MM-DD"),
        };
        ReportsService.crmTransactions(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.crmTransactionRecords = [...data.Records];
            }
            this.$toasted.show(data.message);
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      submitData: function(dataObj) {
        let loader = this.$loading.show();
        this.crmTransactionRecords = [];
        let payload = {
          fromDateTime: moment(this.fromDate).format("YYYY-MM-DD"),
          toDateTime: moment(this.toDate).format("YYYY-MM-DD"),
          isSendData: true,
          dataObj,
        };
        ReportsService.crmTransactions(payload)
          .then((response) => {
            const { data } = response;
            if (data.message.status) {
              this.$toasted.show("CRM updated successfully");
            } else {
              this.$toasted.show("CRM syncing failed");
            }
            console.log(data);
            loader.hide();
          })
          .catch(this._CatchError)
          .then(() => {
            this.getCrmTransactionData();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }
  .swc-report-table td {
    white-space: nowrap;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .no_border {
    border: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/crmTransactions.vue